import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for the SensitivityLabelWarningDialog
 */ export const useSensitivityLabelWarningDialogStyles = makeStyles({
    root: {
        maxWidth: "600px"
    },
    title: {
        paddingBottom: tokens.spacingVerticalS
    },
    titleContent: {
        ...flexParent("row"),
        alignItems: "center",
        gap: tokens.spacingHorizontalS
    },
    warningIcon: {
        display: "flex",
        alignItems: "center",
        color: tokens.colorPaletteRedForeground1,
        fontSize: tokens.fontSizeBase500
    },
    message: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.lineHeightBase300,
        marginBottom: tokens.spacingVerticalL
    },
    dialogActions: {
        display: "flex",
        gap: tokens.spacingHorizontalM,
        justifyContent: "flex-end"
    },
    actionButton: {
        borderRadius: tokens.borderRadiusXLarge,
        minWidth: 0
    }
});
